import script from "./ResponsiveTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponsiveTable.vue?vue&type=script&setup=true&lang=ts"

import "./ResponsiveTable.vue?vue&type=style&index=0&id=678d74f0&lang=scss"

const __exports__ = script;

export default __exports__